// Approved storefront typography, scoped in CSS. ?font=original is a nonpersistent comparison.
export function applyFontPreview({search=window.location.search,defaultOn=true,root=document.documentElement}={}) {
  const choice=new URLSearchParams(search).get('font');
  if(choice==='medeo'||(defaultOn&&choice!=='original')) root.dataset.asansFontPreview='medeo';
  else delete root.dataset.asansFontPreview;
}
